import moment from 'moment';
import { Nullable } from '../types/custom/Nullable';

export const formatBoolean = (value: boolean) => {
    if (value) {
        return 'Yes';
    } else {
        return 'No';
    }
};

// No idea if string is needed as allowed. Just keeping what the original did.
export const formatCurrency = (value: number | string | null) => {
    if (value === 0 || value === '0' || value) {
        return toMoney(value);
    } else {
        return '';
    }
};

export const formatDate = (value: Nullable<moment.MomentInput>, separator: '-' | '/' = '-') => {
    if (value) {
        const formattedDate = moment(value).format(`MM${separator}DD${separator}YYYY`);

        // This condition is not ideal. And this will break if the formatting changes.
        // But it's the easiest way to address this issue across enrollment.
        if (formattedDate === '01-01-0001') {
            return '';
        }
        else {
            return formattedDate;
        }
    } else {
        return '';
    }
};

const toMoney = (value: number | string) => {        
    const valueAsNumber = typeof value === 'number' ? value : parseFloat(value);

    const currencyString = valueAsNumber.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      });
      
    return currencyString;
};